import React from 'react';
import PropTypes from 'prop-types';

import SessionAvatar from './SessionAvatar';

import {
    SpeakerImagesContainer,
    SpeakersContainer,
    SpeakerDetailsContainer,
    SpeakerDetails,
    SessionText,
} from './SessionCard.styles';

export default function Speakers({
    speakers,
    speakerNameStyles,
    speakerTitleCompanyStyles,
    colors,
    activeFonts,
    onClickSpeakerAvatar,
}) {
    return (
        <SpeakersContainer multiple={speakers.length > 1}>
            <SpeakerImagesContainer>
                {speakers.map((speaker) => (
                    <SessionAvatar
                        key={speaker.id}
                        src={speaker.avatarUrl}
                        firstName={speaker.firstName}
                        lastName={speaker.lastName}
                        fontFamily={activeFonts[speakerNameStyles.fontFamily]}
                        onClickSpeakerAvatar={() => onClickSpeakerAvatar(speaker)}
                        dataQa="session_speaker_avatar"
                    />
                ))}
            </SpeakerImagesContainer>
            <SpeakerDetailsContainer>
                {speakers.map((speaker) => {
                    const fullName = [speaker.firstName, speaker.lastName].filter(Boolean).join(' ');
                    const jobTitleAndCompany = [speaker.jobTitle, speaker.company].filter(Boolean).join(', ');

                    return (
                        <SpeakerDetails key={speaker.id}>
                            <SessionText
                                $fontSize={speakerNameStyles.fontSize}
                                $fontColor={colors[speakerNameStyles.fontColor]}
                                $fontFamily={activeFonts[speakerNameStyles.fontFamily]}
                                data-qa="session_speaker_name"
                            >
                                {fullName}
                                {fullName && jobTitleAndCompany && ','}
                            </SessionText>
                            <SessionText
                                $fontSize={speakerTitleCompanyStyles.fontSize}
                                $fontColor={colors[speakerTitleCompanyStyles.fontColor]}
                                $fontFamily={activeFonts[speakerTitleCompanyStyles.fontFamily]}
                                data-qa="session_speaker_job_info"
                            >
                                {jobTitleAndCompany}
                            </SessionText>
                        </SpeakerDetails>
                    );
                })}
            </SpeakerDetailsContainer>
        </SpeakersContainer>
    );
}

Speakers.propTypes = {
    onClickSpeakerAvatar: PropTypes.func.isRequired,
    speakerNameStyles: PropTypes.shape({
        fontColor: PropTypes.number,
        fontSize: PropTypes.number,
        fontFamily: PropTypes.number,
    }).isRequired,
    speakerTitleCompanyStyles: PropTypes.shape({
        fontColor: PropTypes.number,
        fontSize: PropTypes.number,
        fontFamily: PropTypes.number,
    }).isRequired,
    speakers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            avatarUrl: PropTypes.string,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            jobTitle: PropTypes.string,
            company: PropTypes.string,
        }),
    ).isRequired,
    colors: PropTypes.array.isRequired,
    activeFonts: PropTypes.array.isRequired,
};
